import styleLoader from 'utils/style-loader';

import loadIcons, { loadDefs } from './skin/icons-loader';
import settingsMenu from './skin/settings-menu';

const loader = (jwConfig, skinLoader = styleLoader) => {
    // // disable multiple loading of JW skin
    if(jwConfig.skin && jwConfig.skin.url) {
        skinLoader(jwConfig.skin.url);

        if(jwConfig.skin.name) {
            jwConfig.skin = {
                name: jwConfig.skin.name
            };
        } else {
            delete jwConfig.skin;
        }
    }

    return jwConfig;
};

export { loader };

/**
 * Load SVP Skin
 *
 * @param svpPlayer
 * @param options
 */
export default (svpPlayer) => {
    loadDefs(svpPlayer);

    settingsMenu(svpPlayer);
    loadIcons(svpPlayer);
};